var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlame(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83019 14C8.96419 14 11.6854 12.431 11.3234 9.73567C11.1078 8.13099 10.1705 6.42653 9.83486 5.91387C6.65673 1.0596 9.59639 6.51732 7.98431 4.94836C6.37223 3.3794 8.91041 -0.0237394 8.66821 0.000124859C8.52019 0.0147095 7.30041 0.563329 5.97283 1.52886C4.64551 2.4942 3.76012 3.13813 2.99585 4.10352C2.23149 5.06903 1.72893 6.16635 2.07057 7.36213C2.71424 9.61498 1.66827 9.21269 1.30622 8.44833C0.944163 7.68397 1.14529 6.3564 1.14529 6.3564C-0.291988 7.75319 0.179771 10.8774 1.3062 12.069C2.43264 13.2605 4.27322 14 5.83019 14Z",
    fill: "#E6A152"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53876 11.2181C8.66464 13.2211 7.41159 14 6.02115 14C4.63072 14 3.27696 12.915 3.50355 11.2181C3.54366 10.9176 6.20395 13.155 4.67523 11.2181C3.14651 9.28106 6.14207 7.82324 5.41693 6.65565C4.53576 5.23685 8.41288 9.21505 8.53876 11.2181Z",
    fill: "#FEDF83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlame);
export default __webpack_public_path__ + "assets/media/flame.d47abe6d.svg";
export { ForwardRef as ReactComponent };